<template>
  <div>
    <el-row :gutter="0">
      <el-col :span="16">
        <div style="float: left;margin-right: 70px;">
          <a href="./" style="vertical-align:middle;">
            <img src="@/assets/img/logo.png" width="60" height="60" alt="" srcset="" />
          </a>
<!--           <span style="margin:0 40px 0 10px;font-size: 20px;">九天传媒资源中心</span> -->
        </div>
        <el-col class="nav-item" :span="3">
          <router-link class="nav-a" to="/">首页</router-link>
        </el-col>
        <el-col class="nav-item" :span="3">
          <router-link class="nav-a" to="/resources">资源</router-link>
        </el-col>
        <el-col class="nav-item" :span="3">
          <router-link class="nav-a" to="/goods">商品</router-link>
        </el-col>
        <el-col class="nav-item" :span="3">
          <router-link class="nav-a" to="/notice">公告</router-link>
        </el-col>
        <!-- <el-col class="nav-item" :span="3">
          <router-link class="nav-a" to="/">关于我们</router-link>
        </el-col> -->
      </el-col>

      <el-col :span="8">
        <el-row v-if="islogin" :gutter="0">
          <el-col class="nav-item" :span="20" style="float: right; text-align: right;">
            <router-link class="nav-a" to="/member" title="个人中心">
              <el-avatar v-if="avatar" class="nav-avatar" shape="circle" fit="contain" :size="40" :src="avatar" />
              <span v-if="nickname" >{{nickname}}</span>
              <span v-else-if="username" >{{username}}</span>
            </router-link>
          </el-col>
        </el-row>
        <el-row v-else :gutter="0">
          <el-col class="nav-item login-btn" :span="4" :offset="18">
            <router-link class="login-btn-a" to="/login">登录</router-link> /
            <router-link class="login-btn-a" to="/register">注册</router-link>
          </el-col>
<!--           <el-col class="nav-item" :span="4" :offset="16">
            <router-link class="nav-a" to="/login">登录</router-link>
          </el-col>
          <el-col class="nav-item" :span="4">
            <router-link class="nav-a" to="/register">注册</router-link>
          </el-col> -->
        </el-row>
      </el-col>
    </el-row>
    <!-- <el-divider class="divider"></el-divider> -->
  </div>
</template>

<script>
import { getMemberToken, getNickname, getUsername, getAvatar } from '@/utils/userinfo'

export default {
  name: 'AppHeader',
  props: ['login'],
  data () {
    return {
      islogin: false,
      nickname: '',
      username: '',
      avatar: ''
    }
  },
  watch: {
    login: function (nval, oval) {
      this.isLogin()
    }
  },
  created () {
    this.isLogin()
  },
  methods: {
    isLogin () {
      const token = getMemberToken()
      if (token) {
        this.nickname = getNickname()
        this.username = getUsername()
        this.avatar = getAvatar()
        this.islogin = true
      }
    }
  }
}
</script>

<style scoped>
.nav-item {
  line-height: 60px;
}
.nav-a {
  line-height: 0;
  text-decoration: none;
  color: #323336;
}
.nav-a:hover{
  color: #00355f;
}
.nav-avatar {
  vertical-align: middle;
}
.divider {
  margin: 3px 0;
}
.login-btn{
    font-weight: bold;
    background: linear-gradient(45deg, #ff7f00 0%, #ffb100 100%);
    border-radius: 50px;
    border: none !important;
    color: #FFF !important;
    width: 145px;
    line-height: 40px;
    display: inline-block;
    box-shadow: 0 10px 20px -5px rgb(246 179 26 / 90%);
    text-align: center;
    font-family: "Poppins", Arial, Helvetica, sans-serif;
    font-size: 13px;
    transition: all 0.3s ease 0s;
}
.login-btn:hover {
    transform: translateY(5px);
    box-shadow: 0 3px 10px -5px rgb(246 179 26 / 90%);
    background-position: -145px;
    /*background-color: #101010;*/
    color: #fff;
    transition: all 0.3s ease 0s;

}
.login-btn-a{
    border: none !important;
    color: #FFF !important;
    cursor: pointer;
    text-decoration: none;

}
</style>11



// WEBPACK FOOTER //
// src/components/AppHeader/AppHeader.vue